import React from "react";
import {PrePaymentAgreement} from "./PrePaymentAgreement";
import {BrandContext} from "src/modules/brand/BrandContext";
import {BrandConfig} from "src/modules/brand/BrandConfig";

/**
 * The card authorization the borrower legally agrees to.
 *
 * The entity is taken from the brand rather than hardcoded: this text is what the borrower
 * authorizes to charge their card, so under a lender brand it has to name that lender's legal
 * entity. For every current Network Funding brand that value is still "Network Funding, L.P.",
 * which is why the default is unchanged.
 */
export class PrePaymentAgreementCreditCard extends React.Component {

    static contextType = BrandContext;
    context!: BrandConfig;

    render() {
        const entity = this.context.legalEntity;
        // The entity closes a sentence below. "Network Funding, L.P." already ends in a period, so
        // appending one rendered "L.P.." in legal text shown on every card payment; only add it
        // for an entity that doesn't already end the sentence itself.
        const entityEndingSentence = entity.endsWith(".") ? entity : `${entity}.`;
        return (
            <PrePaymentAgreement>
                I hereby authorize {entity} to charge the amount stated above to this credit
                card.
                I understand these fees are to cover costs incurred in processing my application for a
                mortgage
                with {entity} and are non-refundable unless otherwise provided in writing by
                {" "}{entityEndingSentence}{" "}
                I hereby certify that the above named applicant gave verbal authorization to charge the
                amount
                stated above to the credit card shown. I further certify that a copy of this Authorization
                has been provided to the applicant.
            </PrePaymentAgreement>
        );
    }
}
